import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { Button } from "@components/buttons";
import { useRootAppStore } from "@hooks";
import { useFixBody } from "@state/hooks/shared";
import { Checkbox } from "@components/inputs/shared";
import { isGamesTheme } from "@utils";
import { MobilePlatform } from "@state/stores/types";

export default observer(function AppPopup() {
	const {
		appPopupStore: {
			isAppPopupVisible,
			hidePopupForSession,
			redirectToInstallPage,
		},
	} = useRootAppStore<MobilePlatform>();

	const { t } = useTranslation();

	useFixBody(true, isAppPopupVisible);

	const [isChecked, setIsChecked] = useState(false);

	const handleRedirect = () => {
		hidePopupForSession(isChecked);
		redirectToInstallPage();
	};

	//do not display popup on register/terminal route
	if (
		!isAppPopupVisible ||
		location.pathname.includes("register/terminal") ||
		location.pathname.includes("casino-payment") ||
		location.pathname.includes("register/partner") ||
		location.pathname.includes("register") ||
		location.pathname.includes("registration") ||
		location.pathname.includes("login")
	) {
		return null;
	}

	return (
		<div className="at-appInstall popup popup--app">
			<div className="popup__card popup--app__card">
				<div className="popup__header popup--app__header">
					<div className="popup__title popup__title--centered">
						{t<string>("SESSION.INSTALL_APP_POPUP.USE_APP")}
					</div>
				</div>
				<div className="popup__body popup--app__body">
					<div className="card--install__download">
						{isGamesTheme() ? (
							<div className="card--install__row">
								<img
									className="card--install__logo"
									src="/assets/images/app-icon/icon--games--xxxhdpi--radial.png"
									alt=""
								/>
								<div className="card--install__col">
									<div className="card--install__title">
										{t(
											"specific:INFO_PAGES.INSTALL_APP.APP_NAME"
										)}
									</div>
									<div className="card--install__label">
										Tipwin Limited
									</div>
								</div>
							</div>
						) : (
							<div className="card--install__row">
								<img
									className="card--install__logo"
									src="/assets/images/app-icon/icon--betting--xxxhdpi--radial.png"
									alt=""
								/>
								<div className="card--install__col">
									<div className="card--install__title">
										{t(
											"SESSION.INSTALL_APP_POPUP.APP_NAME"
										)}
									</div>
									<div className="card--install__label">
										Tipwin Limited
									</div>
								</div>
							</div>
						)}

						<Button
							type="button"
							atClassName="appInstallBtnPrimary"
							className="btn--base btn--block btn--accent"
							btnText={t("SESSION.INSTALL_APP_POPUP.INSTALL_APP")}
							onClick={handleRedirect}
							iconLeft
							iconClassName="u-icon u-icon--sml u-icon--download u-color--accent--text"
						/>
					</div>

					<div className="popup--app__divider" />
				</div>
				<div className="popup__footer popup--app__footer">
					<div className="popup__footer__row popup__footer__row--centered">
						<div className="input--check">
							<Checkbox
								id="show-popup-checkbox"
								className="input--check__box"
								name="show-popup-checkbox"
								checked={isChecked}
								onClick={() => {
									setIsChecked(!isChecked);
								}}
							/>
							<label
								className="input--check__label"
								htmlFor="show-popup-checkbox"
							>
								{t("SESSION.INSTALL_APP_POPUP.DONT_SHOW_APP")}
							</label>
						</div>
					</div>
					<Button
						type="button"
						atClassName="AppPopup__btn--secondary"
						className="btn--med btn--ghost popup__btn popup__btn--secondary"
						btnText={t("SESSION.INSTALL_APP_POPUP.CLOSE_APP")}
						onClick={() => hidePopupForSession(isChecked)}
					/>
				</div>
			</div>
		</div>
	);
});
